// Copyright (c) 2016 Deere & Company

import './registration-history-item.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import DealerInfo from '../../shared/components/dealer-info';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../shared/components/labeled-string';
import {Link} from 'react-router';
import RegistrationHistory from '@deere/cps-it.warranty-model-factory/lib/registration-history';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../shared/services/build-date';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';

function checkDateValidity(registrationDateMiliSecond, numberOfDays) {

    const registrationDate = new Date(registrationDateMiliSecond);
    const lastSomeDays = new Date();

    lastSomeDays.setDate(lastSomeDays.getDate() - numberOfDays);

    if (registrationDate > lastSomeDays) {

        return true;

    }

    return false;

}
class RegistrationHistoryItem extends Component {
    state = {
        showConfirmUndo: false
    };

    handleOpenConfirmationModal= () => {

        document.body.classList.add('warranty-modal-is-open');

        this.setState({showConfirmUndo: true});

    }

    handleCloseConfirmationModal= () => {

        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmUndo: false});

    };

    handleUndoRegistration = () => {

        this.props.actions.undoRegistration(this.props.registration);
        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmUndo: false});

    };
    render() {

        return (
            <div className='registration-history-item'>
                <header>{this.props.registration.customerSummary.displayName}</header>
                <main className='row'>
                    <LabeledString
                        data={this.props.registration.purchaserType.value}
                        label='PURCHASER_TYPE'
                    />
                    <LabeledString
                        data={buildDate(this.props.registration.deliveryDate)}
                        label='DELIVERED'
                    />
                    <LabeledString
                        data={buildDate(this.props.registration.firstUseDate)}
                        label='FIRST_USE'
                    />
                    <LabeledString
                        data={buildDate(this.props.registration.registrationDate)}
                        label='REGISTERED'
                    />
                    <LabeledString
                        data={this.props.registration.endUseCode.value}
                        label='END_USE'
                    />
                    <DealerInfo
                        dealerId={this.props.registration.responsibleDealer.account}
                        dealerName={this.props.registration.responsibleDealer.name}
                        industryIndicator={this.props.registration.responsibleDealer.industryIndicator}
                        label='RESPONSIBILITY_OF'
                        location={this.props.registration.responsibleDealer.location}
                    />
                </main>
                {!this.props.isRegistrationFormNotAllowed && this.props.registration.statusIndicator.key === 'NEW' &&
                <footer>
                    <SmartFormLink
                        displayText='REGISTRATION_FORM'
                        formName='REGISTRATION'
                        objectId={this.props.registration.id}
                        translate={true}
                    />
                </footer>
        }
                <footer>
                    <section className='button-group'>
                        {this.props.registrationCount === 0 && hasAccess(this.props.security, 'PRT', 'PRT_UNDO_REGISTERATION') && checkDateValidity(this.props.registration.registrationDate, 15) &&
        hasPermission(this.props.user.privacy, 'registrationNotAllowed') &&
            <button
                className='button-secondary'
                onClick={this.handleOpenConfirmationModal}
            >
                <FormattedMessage id='UNDO'/>
                </button>
        }
                        {this.props.registrationCount === 0 && hasAccess(this.props.security, 'PRT', 'PRT_EDIT_REGISTERATION') && checkDateValidity(this.props.registration.deliveryDate, 1825) &&
                        <Link
                            className='primary'
                            to={`/products/register-product?registrationId=${this.props.registration.id}`}
                        >
                            <FormattedMessage id='EDIT'/>
                        </Link>
        }
                    </section>
                </footer>
                <ConfirmationModal
                    confirmMessage='CONFIRM_UNDO_REGISTRATION'
                    isOpen={this.state.showConfirmUndo}
                    onClose={this.handleCloseConfirmationModal}
                    onConfirm={this.handleUndoRegistration}
                    title='UNDO_REGISTRATION'
                />
            </div>
        );

    }
}

RegistrationHistoryItem.displayName = 'RegistrationHistoryItem';
RegistrationHistoryItem.propTypes = {
    actions: PropTypes.object.isRequired,
    isRegistrationFormNotAllowed: PropTypes.bool.isRequired,
    language: PropTypes.string.isRequired,
    registration: PropTypes.instanceOf(RegistrationHistory).isRequired,
    registrationCount: PropTypes.number.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    undoRegistration: PropTypes.func,
    user: PropTypes.instanceOf(User).isRequired
};

export default RegistrationHistoryItem;



// WEBPACK FOOTER //
// ./src/product/details/components/registration-history-item.js